(() => {
  if (customElements.get('alunir-vip-countdown')) return;
  customElements.define('alunir-vip-countdown', class extends HTMLElement {
    connectedCallback() {
      this.endTime = Date.parse(this.dataset.end);
      if (!Number.isFinite(this.endTime)) { this.hidden = true; return; }
      this.tick();
      if (this.endTime > Date.now()) this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const seconds = Math.max(0, Math.ceil((this.endTime - Date.now()) / 1000));
      const pad = value => String(value).padStart(2, '0');
      this.textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(pad).join(':');
      if (seconds === 0) {
        clearInterval(this.timer);
        const label = this.closest('[data-vip-top-countdown]')?.querySelector('[data-vip-top-label]');
        if (label) label.textContent = this.dataset.ended;
      }
    }
  });
})();
